import { mapState } from 'vuex';
import { GENDERSTRINGS } from '@/Scripts/constants';
import superscriptHelper from '@/Scripts/lib/helper/superscriptHelper.js';
import { ProductSortSizes, ProductPrices } from '@/Scripts/lib/helper/productHelper.js';
import { eventBus } from '@/Scripts/lib/helper/eventBus.js';

export default {
  computed: {
    ...mapState({
      wishlistItems: state => state.bag.wishlistItems
    }),
    productName () {
      const superscriptName = superscriptHelper.convert(this.model.Name);
      return GENDERSTRINGS.reduce((result, word) => result.replace(word, ''), superscriptName);
    },
    variants () {
      if (typeof this.model === 'undefined' || !this.model) {
        return [];
      }
      if (this.archived) {
        return this.model.ArchivedVariants;
      } else if (this.outlet) {
        return this.model.OutletVariants;
      }
      return this.model.ActiveVariants;
    },
    currentVariant () {
      return this.variants[this.colorVariantIndex];
    },
    currentVariantPrice () {
      return ProductPrices(this.currentVariant);
    },
    currentVariantSizes () {
      if (this.currentVariant) {
        return ProductSortSizes(this.currentVariant.SizeVariations);
      }
      return [];
    },
    selectedSizeObject () {
      if (this.sizeVariantIndex === -1) {
        return null;
      }
      return this.currentVariantSizes[this.sizeVariantIndex];
    },
    selectedSizeOnWishlist () {
      if (this.wishlistItems && this.wishlistItems.length && this.selectedSizeObject) {
        return this.wishlistItems.some(item => item.Model === this.model.Code && item.Color === this.currentVariant.ColorCode && item.Size === this.selectedSizeObject.Size);
      }
      return false;
    },
    hasSizeOnWishlist () {
      if (this.wishlistItems && this.wishlistItems.length) {
        return this.wishlistItems.some(item => item.Model === this.model.Code && item.Color === this.currentVariant.ColorCode);
      }
      return false;
    }
  },
  methods: {
    openWishlistModal () {
      eventBus.$emit('WISHLIST_ADD', {
        productModel: this.model,
        colorModel: this.currentVariant,
        sizes: this.currentVariantSizes,
        sizeIndex: this.sizeVariantIndex,
        outlet: this.outlet
      });
    }
  }
};
